export default {
  ICON_STATUT: 'mdi mdi-checkbox-blank-circle',
  ICON_START: 'fas fa-play',
  ICON_FINISH: 'fas fa-thumbs-up',
  ICON_STOP: 'fas fa-stop',
  ICON_RESET: 'fas fa-hourglass',
  ICON_PAUSE: 'fas fa-pause',
  ICON_DESCRIPTION: 'mdi mdi-comment-edit',
};
